<script lang="ts">
export default {
  name: 'KkPostPreviewLayout',
}
</script>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { KkSiteIcon } from '../../../../components/base'
import { castSnakeToCamel } from '../../../../modules/string_converter'
import type { Post, AvailablePostService } from '../../types'

const { t } = useI18n()

interface Props  {
  service: AvailablePostService
  post: Post
  hasContent: boolean
}
const props = defineProps<Props>()
</script>

<template>
  <div class="preview">
    <div class="preview__header">
      <KkSiteIcon :name="props.service" class="preview__header__icon" />
      {{ t(`pages.CompaniesStorePost.service.${castSnakeToCamel(props.service)}`) }}
    </div>
    <div v-if="hasContent" class="preview__body">
      <div class="preview__content">
        <slot />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.preview {
  margin: 0 auto;
  border: 3px solid #3A3B3F;
  border-radius: 4px;
  background-color: #f1f1f1;

  &__header {
    display: flex;
    align-items: center;
    background: #3A3B3F;
    color: #fff;
    padding: 10px;
    font-weight: bold;

    &__icon {
      width: 16px;
      height: 16px;
      margin: 0 10px;
      background: #fff;
      border-radius: 2px;
      padding: 2px;
    }
  }

  &__body {
    width: 80%;
    margin: 0 auto;
    padding: 10px 0;
  }

  &__content {
    background-color: #fff;
    padding-bottom: 20px;
  }

  &__icon {
    width: 16px;
    height: 16px;
    margin: 0 10px;
    background: #fff;
    border-radius: 16px;
  }

  &__imageWrapper {
    padding-top: 12px;
  }

  &__image {
    margin: 2px;
    width: 100%;
  }

  &__text {
    padding: 16px 16px 0;
    white-space: pre-wrap;
    word-break: break-all;
  }
}
</style>
